const enum ResourcesStoreParts {
  DOCUMENTS = 'documents',
  DOCUMENTS_EXECUTED = 'documentsExecuted',
  COLLECTIONS = 'collections',
  COLLECTIONS_EXECUTED = 'collectionsExecuted'
}

export default ResourcesStoreParts;